import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FlowMeterService } from 'src/app/service/flowmeter.service';

@Component({
  selector: 'app-setparameter-flowmeter',
  templateUrl: './setparameter-flowmeter.component.html'
})
export class SetparameterFlowmeterComponent implements OnInit {

  // Property Declaration
  setparameterForm: FormGroup;
  RoleName: string = '';
  DisplayButton: boolean = true; // Mayank
  SiteMasterList: any;
  IsreadOnly: boolean = false;
  IsreadOnly1: boolean = false;
  EnergyMeterId: string = '';
  Type: string = '';
  errorMsg: string = '';
  successMsg: string = '';
  UserId: number;
  IsfromAddSite: boolean = false;
  constructor(private flowmeterservice: FlowMeterService, private form: FormBuilder, private dialog: MatDialog, public dialogRef: MatDialogRef<SetparameterFlowmeterComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
    if (data && data.SiteMasterList) {
      this.SiteMasterList = data.SiteMasterList;
      this.IsfromAddSite = data.IsfromAddSite;
    }
    if (data && data.EnergyMeterId) {
      this.EnergyMeterId = data.EnergyMeterId;
    }
  }

  ngOnInit(): void {
    this.RoleName = localStorage.getItem('RoleName');
    this.UserId = +localStorage.getItem('UserId');
    this.setparameterForm = this.form.group({
      VaccumeTransmitter: [''],
      LowLevelTransmitter: [''],
      Calibration: ['']
    });

    // Mayank
    if (this.RoleName == 'PortalAdmin') {
      this.DisplayButton = false;
      this.IsreadOnly = true;
    }
    else {
      this.DisplayButton = true;
      this.IsreadOnly = false;
    }

    if (this.EnergyMeterId == 'SIPL1000000004000001' || this.EnergyMeterId == 'SIPL1000000004000002') {
      this.Type = 'RMSPRAYAS';
    }
    else {
      this.Type = 'EMS';
    }

    if (this.SiteMasterList != null) {
      this.SetSiteDetails();
    }
  }

  // Set Parameter Values
  SetSiteDetails() {
    if (this.Type == 'RMSPRAYAS') {
      this.setparameterForm.patchValue({
        VaccumeTransmitter: this.SiteMasterList.ThresholdFlowRate,
        LowLevelTransmitter: this.SiteMasterList.ThresholdTotalizer,
        Calibration: this.SiteMasterList.Calibration
      });
    }
    else {
      this.setparameterForm.patchValue({
        VaccumeTransmitter: this.SiteMasterList.VaccumeTransmitter,
        LowLevelTransmitter: this.SiteMasterList.LowLevelTransmitter,
        Calibration: this.SiteMasterList.Calibration
      });
    }
  }

  // Call on click Save button
  OnSubmit(): void {

    var Setparamvalue = { ...this.setparameterForm.value };
    var ReqObj = {};
    if (this.Type == 'RMSPRAYAS') {
      ReqObj = {
        DeviceId: this.EnergyMeterId,
        UserId: this.UserId,
        ThresholdFlowRate: Setparamvalue.VaccumeTransmitter,
        ThresholdTotalizer: Setparamvalue.LowLevelTransmitter,
        Calibration: Setparamvalue.Calibration,
        Type: 'RMSPRAYAS'
      };
    }
    else {
      ReqObj = {
        DeviceId: this.EnergyMeterId,
        UserId: this.UserId,
        VaccumeTransmitter: Setparamvalue.VaccumeTransmitter,
        LowLevelTransmitter: Setparamvalue.LowLevelTransmitter,
        Calibration: Setparamvalue.Calibration,
        Type: 'EMS'
      };
    }
    this.successMsg = '';
    this.errorMsg = '';
    if (!this.IsfromAddSite) {
      this.flowmeterservice.UpdateFlowParameter(ReqObj).subscribe(
        (result) => {

          if (result.Response == 'success') {
            this.successMsg = 'Values submitted successfully';
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
    else {
      this.dialogRef.close(ReqObj);
    }
  }

  // Call on click Cancel button
  OnCancel() {
    var ReqObj = {
      VaccumeTransmitter: 0,
      LowLevelTransmitter: 0,
      ThresholdFlowRate: 0,
      ThresholdTotalizer: 0,
      Calibration: 0
    };
    this.dialogRef.close(ReqObj);
  }

  // called on close icon
  Close() {
    this.dialogRef.close();
  }
}
